import { Link } from "react-router-dom";

export function ToolCard({ tool }) {
    const Icon = tool.icon;
    return (
        <div
            className="border-2 border-black p-6 bg-white hover:bg-[#F0F9FF] transition-colors flex flex-col justify-between group"
            data-testid={`tool-card-${tool.slug}`}
        >
            <div>
                <div className="w-11 h-11 border-2 border-black bg-[#F0F9FF] flex items-center justify-center group-hover:bg-black transition-colors">
                    <Icon className="w-5 h-5 text-black group-hover:text-[#22D3EE] transition-colors" aria-hidden="true" />
                </div>
                <h3 className="font-bold text-lg text-black mt-3">{tool.name}</h3>
                <p className="text-xs text-gray-700 mt-2 leading-relaxed">{tool.desc}</p>
            </div>
            <Link
                to={`/ferramentas/${tool.slug}`}
                data-testid={`open-tool-${tool.slug}`}
                className="mt-6 font-mono-tag text-xs font-bold text-black uppercase underline decoration-[#0284C7] decoration-2 underline-offset-4 hover:text-[#0284C7] transition-colors self-start"
            >
                Abrir Ferramenta
            </Link>
        </div>
    );
}
